<template>
  <div class="sale-entry">
    <div class="text-size-30">エントリー</div>
    <div class="mr-b-10">
      <a class="text--underline" @click.stop="$emit('backToTop')">戻る</a>
    </div>
    <div class="sale-card">
      <sale-detail :sale="selectedSale" />
      <hr>
      <sale-entry-running :sale="selectedSale" v-if="disabledEntry" />
      <sale-entry-products
        v-else
        @settingDisabled="settingDisabled"
        @updateSale="updateSale"
        ref="saleEntryProducts"
      />
      <hr>
      <div v-html="selectedSale.detailhtml"></div>
      <div class="mr-t-10">
        <a class="text--underline" @click.stop="$emit('backToTop')">戻る</a>
      </div>
      <div v-if="!disabledEntry" class="text-center mr-b-30">
        <p class="text-danger">必ずセール内容をお読みのうえエントリーください。</p>
        <button :disabled="disabled" class="btn btn-warning" @click="handlePostSaleEntry">
          エントリーする
          <i class="fa fa-hand-o-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SaleDetail from './components/SaleDetail'
import SaleEntryRunning from './components/SaleEntryRunning'
import SaleEntryProducts from './components/SaleEntryProducts'
import moment from 'moment'
import 'moment/locale/ja'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    selectedSale: {
      type: Object,
      default () {
        return null
      }
    }
  },
  components: {
    SaleDetail,
    SaleEntryRunning,
    SaleEntryProducts
  },
  computed: {
    saleId () {
      return this.$route.params.saleId
    },
    disabledEntry () {
      moment.locale('ja')
      const endDate = moment(this.selectedSale.applicationPeriodTo)
      const now = moment()
      return endDate.isBefore(now)
    }
  },
  data () {
    return {
      disabled: true
    }
  },
  methods: {
    settingDisabled (disabled) {
      this.disabled = disabled
    },
    handlePostSaleEntry () {
      if (this.disabled) {
        return false
      }
      this.$refs.saleEntryProducts.openModalConfirm()
    },
    updateSale () {
      this.selectedSale.hasEntry = true
    }
  },
  mounted () {
    const logParams = {
      name: eventCode.sale.entry.show,
      properties: {
        saleId: this.saleId
      }
    }
    EventService.postTrackLog(logParams)
  }
}
</script>
<style scoped>
.sale-card {
  background: white;
  border: 1px solid #ccc;
  padding: 10px;
  position: relative;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
.sale-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
hr {
  border: 2px solid #eee;
}
.btn {
  font-size: 24px;
  padding: 15px 100px;
  font-weight: 600;
}
@media (max-width: 425px) {
  .btn {
    padding: 15px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sale/SaleEntry.vue